var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],staticClass:"global-loading__wrapper",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"global-loading__main"},[_c('div',{staticClass:"circle"}),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.message)+"...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }